module.exports = __webpack_public_path__ + "files/6f6334461fb51f4b21af8bf07e4d8e4e.png";